module.exports = {
  message: {
    "Account": '用戶管理',
    "Home page management": "主頁管理",
    "Online magazine management": "飛雲雜誌管理",
    "Issue management": "主題管理",
    "Article management": "文章管理",
    "Sub-category management": "副類別管理",
    "User Listing": "用戶列表",
    "Role listing": "角色列表",
    "userName": "用戶名稱",
    "Status": "狀態",
    "Search": "搜尋",
    "datagridresult": "條結果",
    "RoleName": "角色名稱",
    "createdTime": "創建日期",
    "Add": "新增",
    "Delete": "刪除",
    "password": "密碼",
    "Tel": "電話",
    "email": "電郵",
    "Role": "角色",
    "Active": "已啟動",
    "Inactive": "尚未啟動",
    "Save": "儲存",
    "Cancel": "取消",
    "Confirm": "確認",
    "Warning": "警告",
    "RoleType": "角色類型",
    "Super Admin": "超級管理員",
    "Platform": "平台管理員",
    "FunctionSelection": "功能",
    "subCategoryName": "副類別",
    "Category": "類別",
    "subCategory": "副類別",
    "All": "--- 全部 ---",
    "selectDefault": "--- 默認 ---",
    "PleaseSelect": "--- 請選擇 ---",
    "title": "標題",
    "issueNumber": "期號",
    "Job function": "相關職能",
    "occupation": "相關職業",
    "LogOut": "登出",
    "Issue": "Issue",
    "Resource library management": "Resource library management",
    "Resource category management": "Resource category management",
    "Link management": "Link management",
    "name": "name",
    "English": "英文",
    "Simplified Chinese": "簡體",
    "Traditional Chinese": "繁體",
    "issueName": "主題",
    "HomePage": "主頁",
    "userDetail": "用戶資料",
    "roleDetail": "角色資料",
    "articleList": "文章列表",
    "articleDetail": "文章資料",
    "subCategoryList": "副類別列表",
    "subCategoryDetail": "副類別資料",
    "issueList": "主題列表",
    "issueDetail": "主題資料",
    "resourceList": "resourceList",
    "resourceDetail": "resourceDetail",
    "resourceCategoryList": "resourceCategoryList",
    "resourceCategoryDetail": "resourceCategoryDetail",
    "Course management": "課程管理",
    "courseImport": "Course Import",
    "Area Of Study management": "Area Of Study management",
    "areaOfStudyImport": "areaOfStudyImport",
    "Add Banner": "增加橫幅",
    "Add hot picks": "增加熱門",
    "Save as draft": "儲存為草稿",
    "Publish": "發佈",
    "Draft": "草稿",
    "Published": "已發佈",
    "Banner": "橫幅 (最少: 1; 最多: 5)",
    "Article title:": "文章標題:",
    "Hot picks": "熱門 (必定是3)",
    "Ready to Publish": "準備發佈",
    "Article title": "文章標題",
    "Preview": "預覽",
    "Edit": "編輯",
    "Author/Interviewee name": "作者/受訪者名稱",
    "Author/Interviewee title": "作者/受訪者標題",
    "Author/Interviewee icon": "作者/受訪者頭像",
    "Short description": "短述",
    "Facebook article ID": "Facebook文章ID",
    "Cover image": "封面圖片",
    "Cover image alt text": "封面圖片alt text",
    "Content editor": "內容編輯器",
    "Slideshow": "幻燈片",
    "Tags": "標籤",
    "tagsTip": '利用 ";" 分隔標籤',
    "Add tag": "增加標籤",
    "Recommended articles": "推介文章",
    "Maximum 5": "最多5個",
    "Image size error": "圖片檔案大小錯誤！",
    "Dimension Error": "圖片尺寸錯誤！",
    "deleteContent": "您確定要刪除所選內容嗎？",
    "Are you sure to publish": "您確定要發佈嗎？",
    "Are you sure to readyToPublish": "您確定要準備發佈嗎？",
    "Are you sure to edit": "您確定要將文章下架編輯嗎？",
    "Must be 3": "一定要3個",
    "MinimumMaximum": "最少1個，最多10個",
    "Minimum 5 occupation": "最少5個職業",
    "floatingBanner": "浮動橫幅",
    "Floating banner management": "浮動橫幅管理",
    "floatingBannerList": "浮动横幅列表",
    "bannerImage": "橫幅圖片",
    "bannerName": "橫幅名稱",
    "bannerContent": "橫幅內容",
    "buttonUrl": "按鈕鏈接",
    "floatingBannerDetail": "浮動橫幅資料",
    "Add floating banner": "增加浮動橫幅",
    "FloatingBanner name:": "浮動橫幅名稱:",
    "FloatingBanner name": "浮動橫幅名稱",
    "FloatingBannerNum": "浮動橫幅 (最少: 1; 最多: 5)",
    "updatedTime": "更新日期",
    "Department banner management": "部門橫幅管理",
    "departmentBanner": "部門橫幅",
    "departmentBannerList": "部門橫幅列表",
    "Add department banner": "增加部門橫幅",
    "DepartmentBanner name:": "部門橫幅名稱:",
    "DepartmentBanner name": "部門橫幅名稱",
    "departmentBannerDetail": "部門橫幅資料",
    "DepartmentBannerNum": "部門橫幅 (最少: 1)",
    "Banner management": "橫幅管理",
    "Top banner management": "頂部橫幅管理",
    "topBannerList": "頂部橫幅列表",
    "topBannerDetail": "頂部橫幅資料",
    "TopBanner name": "頂部橫幅名稱",
    "TopBanner name:": "頂部橫幅名稱:",
    "Name": "名稱",
    "shortDescription": "簡要說明",
    "url": "鏈接",
    "TopBannerNum": "頂部橫幅 (最少: 1; 最多: 20)",
    "Add top banner": "增加頂部橫幅",
    "topBanner": "頂部橫幅",
    "Career magazine": "職業雜誌",
    "Add magazine": "增加雜誌",
    "Career magazineNum": "職業雜誌 (必定是3)",
    "floating bannerContent": "浮動橫幅内容",
    "Job import management": "職位空缺上傳管理",
    "jobImportList": "職位空缺上傳列表",
    "JobSource name": "職位空缺來源名稱",
    "Period": "時間",
    "Import": "導入",
    "active": "已啟動",
    "inactive": "取消啟動",
    "Pending": "待派發",
    "Expired": "過期",
    "To": "至",
    "startTime": "開始時間",
    "endTime": "結束時間",
    "upload": "上傳",
    "download": "下載模板",
    "lastFile": "上次上傳檔案",
    "last update time": "上次上傳時間",
    "Instant Filter": "快速搜索 開/關",
    "On": "開",
    "Off": "關",
    "Instant filter status": "快速搜索狀態",
    "Occupation management": "職業管理",
    "Resource management": "資源管理",
    "Info Centre management": "資訊中心管理",
    "Quiz management": "小測試管理",
    "Quiz Popup": "小測試彈窗",
    "Import QR course": "QR課程上傳",
    "Import CEF course": "CEF課程上傳",
    "Import VTC CIP": "VTC-CIP / QR-CIP上傳",
    "Import Area of Study": "學科上傳",
    "Import Delivery mode": "學習模式上傳",
    "Import Level": "課程級別上傳",
    "Upload success": "上傳成功",
    "Original Img": "原圖上傳",
    "Crop Img": "縮圖上傳",
    "Select file": "選擇文件",
    "Import Occupation": "職業上傳",
    "Import Info Centre": "資訊中心上傳",
    "Import Resource": "資訊上傳",
    "Import Tag": "標籤上傳",
    "System Theme management": "單色模式",
    "SaveSuccess": "儲存成功",
    "StartTimeLessThanEndTime": "開始時間必須小於結束時間",


    "Eight centre management": "八大中心管理",
    "Eight centre list management" : "中心管理",
    "Eight centre detail management" : "中心資訊管理",
    "Centres Name": "中心名稱",
    "Centres Content" : "中心內容",
    "Add Centres Content" : "更新中心內容",

    "Sub-title": "副標題",
    "Add Factor": "添加因素",
    "Add Demand": "新增需求",
    "Add Section": "新增版塊",
    "Add Skill": "添加技能",
    "Add Knowledge": "添加知識",
    "Add New Item" : "新增項目",
  }
}